import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import './index.css';
import App from './App';
import { initDeepLinks } from '@/lib/deep-link';
import { initKeyboardInsets } from '@/lib/keyboard-insets';
import { queryClient } from '@/lib/queryClient';
import { initPush } from '@/lib/push';
import { initAppFocusTracking } from '@/lib/app-focus';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { AppCrashView } from '@/components/AppCrashView';

initDeepLinks();
initKeyboardInsets();
// HEAL-46b: слушатели push ставятся до авторизации — тап по уведомлению может
// прийти на холодный старт, и потерять его нельзя.
initPush();
initAppFocusTracking();

// Отключаем браузерное scroll-restoration: SPA сам скроллит к топу через useEffect-ы.
// Иначе на pushState (wouter navigation) iOS Safari иногда подкручивает scroll обратно
// к запомненной позиции, перебивая ручной reset.
if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      {/* HEAL-47: последний рубеж. Внутренняя граница (App.tsx) ловит падения
          экранов; эта — падение самих провайдеров и всего, что выше роутера.
          Сброса здесь нет: если рухнул корень, честнее перезагрузка. */}
      <ErrorBoundary
        scope="app-root"
        fallback={() => <AppCrashView onRetry={() => window.location.reload()} />}
      >
        <App />
      </ErrorBoundary>
    </QueryClientProvider>
  </StrictMode>,
);
